import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'credo-bank-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
